import styled from "styled-components";

export default styled.div`
    text-align: center;
    font-weight: 300;
    font-style: italic;
    position: relative;
    margin-bottom: 12px;
    &:before {
        content: "";
        width: 100%;
        height: 1px;
        position: absolute;
        left: 0;
        top: 10px;
        opacity: 0.5;
        background-color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : p.theme.c.dark};
    }

    > span {
        z-index: 1;
        position: relative;
        background-color: ${p => p.theme.c.snow};
        padding: 4px 12px;
    }
`;
